import {Component, EventEmitter, Injector, Output} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {ModalBaseComponent} from '../modal-base-component';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent extends ModalBaseComponent {

  public ids: Array<number>;
  public type: string;
  public iccid: string;

  @Output() action = new EventEmitter();

  constructor(private inject: Injector, private _bsModalRef: BsModalRef) {
    super(inject);
  }

  // call this whenever you want to close modal
  public closeModal(): void {
    this._bsModalRef.hide();
  }

  public delete() {
    this.action.emit(true);
    this.closeModal();
  }

}




// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/confirm-dialog/confirm-dialog.component.ts